export default __webpack_public_path__ + "images/63_1_image.jpg";